// extracted by mini-css-extract-plugin
module.exports = {"inviteButton":"style__inviteButton__tndsY"};